var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mediaItem.poster && _vm.mediaItem.thumbnails
    ? _c(
        "md-layout",
        { attrs: { id: "thumbnails", "md-flex": "100" } },
        [
          _c("div", { staticClass: "md-headline" }, [_vm._v("Thumbnail")]),
          _c("md-layout", { attrs: { "md-flex": "100" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.thumbnailView === "autogenerated",
                    expression: 'thumbnailView === "autogenerated"'
                  }
                ],
                key: "autogeneratedView",
                staticClass: "thumbnailContainer"
              },
              _vm._l(_vm.getThumbnails(), function(poster) {
                return _c("div", [
                  !poster.match("uploaded")
                    ? _c("img", {
                        staticClass: "thumbnail",
                        class: {
                          selected: _vm.mediaItem.poster.desktop === poster
                        },
                        attrs: {
                          src: poster.startsWith("http")
                            ? poster
                            : "//" + _vm.imageServerBase + "/" + poster
                        },
                        on: {
                          click: function($event) {
                            return _vm.changePoster($event, poster)
                          }
                        }
                      })
                    : _vm._e()
                ])
              }),
              0
            )
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37383c91", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37383c91","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/mediaItem/MediaItemPosterSelector.vue
// module id = 946
// module chunks = 0